import React from "react";
import {

} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  KeyboardBackspace
} from "@mui/icons-material";
import {useHistory} from "react-router-dom";

const HeadTitleGoBack = ({ title, Icon, isGoBack }) => {
  const classes = useStyles();
  const history = useHistory();
  
  const handleGoBack = () => {
    if (!isGoBack) return
    history.goBack();
  }
  return (
    <div className={classes.root} onClick={handleGoBack}>
      {isGoBack && (
        <div className={classes.goBack}>
          <KeyboardBackspace sx={{color: "white", fontSize: "24px"}}/>
        </div>
      )}
      {Boolean(Icon) && (
        <div className={classes.icon}>
          <Icon color="primary" sx={{fontSize: "24px"}}/>
        </div>
      )}
      <div className={classes.name}>{title}</div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    gap: "8px",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  name: {
    fontSize: 18,
    color: "white",
    fontWeight: "500",
    lineHeight: "22px",
  },
  goBack: {
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default HeadTitleGoBack
